import * as React from 'react'

import { Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { ShiftInfo } from 'modules/timeoff/components/LeaveApprovalRecommendation/getRecommendationDescriptionRich'

interface Props {
  visible: boolean
  onClose: () => void
  shiftsInfo: ShiftInfo[]
  leaveStart: string
  leaveEnd: string
  employeeRequestName: string
  onGoToShifts: () => void
}

const ShiftCoverageModal = ({
  visible,
  onClose,
  shiftsInfo: _shiftsInfo,
  leaveStart,
  leaveEnd,
  employeeRequestName,
  onGoToShifts,
}: Props) => {
  if (!visible) return null

  let range = ''
  if (leaveStart && leaveEnd) {
    const start = new Date(leaveStart)
    const end = new Date(leaveEnd)
    const sameDay = start.toDateString() === end.toDateString()
    if (sameDay) {
      range = `(${start.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })})`
    } else {
      range = `(${start.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })}–${end.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })})`
    }
  }

  return (
    <Modal
      title={i18n.t('time_off.approval_recommendation.shift_title_modal')}
      description={
        <>
          <Text.Normal>
            {i18n.t('time_off.approval_recommendation.shift_modal_description', {
              employee: employeeRequestName,
              range: range,
            })}
          </Text.Normal>
        </>
      }
      illustration="document-edit"
      onClose={onClose}
      footer={
        <Button type="primary" onClick={onGoToShifts}>
          {i18n.t('time_off.approval_recommendation.shift_button_modal')}
        </Button>
      }
    />
  )
}

export default ShiftCoverageModal
